import { SortingService } from '@lib/util';

export interface IInvoiceGroupItem {
    itemId: string;
    invoicePosition: number;
    orderId: string | null;
    orderErpNumber?: string | null;
    receiptNumber: string | null;
    receiptId: number | null;
}

export class InvoiceItemGroup<T extends IInvoiceGroupItem> {
    public static groupItems<T extends IInvoiceGroupItem>(items: T[]): InvoiceItemGroup<T>[] {
        const itemGroups: InvoiceItemGroup<T>[] = [];
        for (const item of items) {
            let group = itemGroups.find((group) => group.orderNumber === item.orderId);
            if (!group) {
                group = new InvoiceItemGroup(item);
                itemGroups.push(group);
            }

            group.orderErpNumber = group.orderErpNumber ?? item.orderErpNumber ?? null;
            group.addItem(item);
        }

        for (const group of itemGroups) {
            SortingService.sort(group.items, (item) => item.invoicePosition);
        }

        SortingService.sort(itemGroups, (group) => group.items.reduce((acc, item) => acc + item.invoicePosition, ''));

        return itemGroups;
    }

    orderNumber: string | null;
    orderErpNumber: string | null;
    receiptNumber: string | null;
    receiptId: number | null;
    private readonly _items: T[];

    get items(): T[] {
        return this._items;
    }

    constructor(item: T) {
        this.orderNumber = item.orderId;
        this.orderErpNumber = item.orderErpNumber ?? null;
        this.receiptNumber = item.receiptNumber;
        this.receiptId = item.receiptId;
        this._items = [];
    }

    public addItem(item: T) {
        const existingItem = this._items.find((i) => i.itemId === item.itemId);
        if (!existingItem) {
            this.items.push(item);
        }
    }
}
